<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm12 md10 offset-md1>
        <v-card>
          <v-card-title>
            Relatório de Dividas
            <v-spacer></v-spacer>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="3">
                <v-menu
                  ref="menu1"
                  v-model="menu1"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="mr-2 ml-2"
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateFormatted1"
                      label="Data Criação Inicial"
                      persistent-hint
                      class="mr-2 ml-2"
                      prepend-icon="event"
                      @blur="date1 = parseDate(dateFormatted1)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date1"
                    class="mr-2 ml-2"
                    locale="pt-br"
                    no-title
                    @input="menu1 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="menu2"
                  v-model="menu2"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  full-width
                  class="mr-2 ml-2"
                  max-width="290px"
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="dateFormatted2"
                      label="Data Criação Final"
                      persistent-hint
                      class="mr-2 ml-2"
                      prepend-icon="event"
                      @blur="date2 = parseDate(dateFormatted2)"
                      v-on="on"
                    ></v-text-field>
                  </template>
                  <v-date-picker
                    v-model="date2"
                    class="mr-2 ml-2"
                    locale="pt-br"
                    no-title
                    @input="menu2 = false"
                  ></v-date-picker>
                </v-menu>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-autocomplete
                  v-model="filtros.idcliente"
                  :items="clientes"
                  class="mr-2 ml-2"
                  v-show="user ? user.acesso != 'Cliente' : false"
                  chips
                  color="blue-grey lighten-2"
                  label="Clientes"
                  item-value="_id"
                  item-text="Nome"
                  multiple
                >
                </v-autocomplete>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="6">
                <v-btn
                  small
                  color="green"
                  class="mr-2 ml-2"
                  @click="exportarExcel(filtros)"
                >
                  <v-icon>assignment</v-icon>
                  Gerar Excel
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import store from "@/store";
import { mapMutations } from "vuex";
import usuarioCtrl from "@/services/usuario";
import clienteCtrl from "@/services/cliente";
import dividasCtrl from "@/services/dividas";
import { json2excel, excel2json } from "js2excel";

export default {
  name: "Email",
  data() {
    return {
      filtros: {},
      clientes: [],
      user: null,
      dateFormatted1: '',
      dateFormatted2: '',
      menu1: false,
      menu2: false,
      date1: new Date().toISOString().substr(0, 10),
      date2: new Date().toISOString().substr(0, 10),
    };
  },
  async created() {
    this.setLoading(true);
    this.clientes = await clienteCtrl.getClientes();
    if (store.getters.user) {
      this.user = await usuarioCtrl.getUsuario(store.getters.user._id);
    }
    this.setLoading(false);
  },
  computed: {
    computedDateFormatted1() {
      return this.formatDate(this.date1);
    },
    computedDateFormatted2() {
      return this.formatDate(this.date2);
    },
  },
    watch: {
      date1 (val) {
        this.dateFormatted1 = this.formatDate(this.date1)
        this.filtros.dateCreatedInit = this.date1;
      },
      date2 (val) {
        this.dateFormatted2 = this.formatDate(this.date2)
        this.filtros.dateCreatedEnd = this.date2;
      },
    },
  methods: {
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    async exportarExcel(filtros) {
      this.setLoading(true);
      let dividas = await dividasCtrl.getDividas({ filtros: filtros });
      console.log(dividas);
      //let dividas = await dividasCtrl.getDividasAll();


      let data = [];
      dividas.forEach((divida) => {
        let object = {
          Contrato: divida.Identificador,
          Empresa: divida.idcliente.Nome,
          Devedor: divida.iddevedor.Nome,
          CPF: divida.iddevedor.CnpjCpf,
          "Status Divida": this.getStatusDivida(divida),
          "Devedor Bloqueado": divida.iddevedor.IsAtivo ? "Não" : "Sim",
          "Data Nascimento": divida.iddevedor.DataNascimento,
          Endereço: divida.iddevedor.Endereco,
            "Telefone 1":
           divida.iddevedor.TelefonePrincipal && divida.iddevedor.TelefonePrincipal,
          "Telefone 2":
            divida.iddevedor.Telefone2 && divida.iddevedor.Telefone2,
          "Telefone 3":
            divida.iddevedor.Telefone3 && divida.iddevedor.Telefone3,
          Especificação: divida.Especificacao,
          "Tipo Produto": divida.TipoProduto,
          Juro: divida.Juros,
          "Tipo Juro": divida.TipoJuro,
          "Data da Divida": divida.DataDivida,
          "Valor Divida": divida.ValorDivida,
          "Valor Empresa": divida.ValorEmpresa,
        };

        data.push(object);
      });
      try {
        json2excel({
          data,
          name: "RelatorioDividas",
          formateDate: "dd/mm/yyyy",
        });

        this.setLoading(false);
      } catch (e) {
        this.setLoading(false);
        console.error("export error");
      }
    },
    getStatusDivida(divida) {
      if (divida && divida.ValorRepasse === 0) {
        return "Quitado";
      }
      if (divida.StatusDivida == 1) {
        return "Processo Cobrança";
      } else if (divida.StatusDivida == 2) {
        return "Aguardando Aprovação";
      } else if (divida.StatusDivida == 3) {
        return "Acordo Vigente";
      } else if (divida.StatusDivida == 4) {
        return "Acordo em Atraso";
      } else if (divida.StatusDivida == 5) {
        return "Divida Bloqueada";
      } else if (divida.StatusDivida == 6) {
        return "Deslocalizado";
      } else if (divida.StatusDivida == 8) {
        return "Bloqueado";
      }
    },
    ...mapMutations({
      setDevedor: "setDevedor",
      setLoading: "setLoading",
    }),
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/relatorios/Dividas.vue